import { bindEvents, easing } from '../helpers';

import AnimationController from './animation';


let scrollWrapper = null;
let scrollContent = null;
let contentHeight = 0;

class ScrollController {

	constructor() {
		this.content = null;

		this.rendering = true;

		this.position = {
			duration: 45,
			easing: 'easeOutQuart',
			from: 0,
			to: 0,
			current: 0,
			frame: 0
		};

		this.direction = 0;

		this.jump = false;

		this.animation = null;

		this.events = bindEvents(this);

		this.addEventListeners();
		this.measure();
	}

	get scrollContent() {
		return scrollContent;
	}

	set scrollContent(el) {
		scrollContent = el;
		this.measureContentHeight();
	}

	get scrollWrapper() {
		return scrollWrapper;
	}

	set scrollWrapper(el) {
		scrollWrapper = el;
		return true;
	}

	get contentHeight() {
		return contentHeight;
	}

	set contentHeight(height) {
		if (height !== contentHeight) {
			contentHeight = height;
			this.renderBodyHeight();
		}
		return true;
	}

	measureContentHeight() {
		if (this.scrollWrapper) this.contentHeight = this.scrollWrapper.offsetHeight;
	}

	updateContentHeight() {
		this.measureContentHeight();
	}

	measure() {
		this.viewport = window.innerHeight;
		this.measureContentHeight();
	}

	renderBodyHeight() {
		document.body.style.height = `${this.contentHeight}px`;
	}

	updateDirection(top) {
		if (top > this.position.current) {
			this.direction = 1;
		} else if (top === this.position.current) {
			this.direction = 0;
		} else {
			this.direction = -1;
		}
	}

	updateScrollTo(top) {
		this.position.from = this.position.current;
		this.position.to = top;
		this.position.frame = this.position.duration;
	}

	updateJumpTo(top) {
		this.position.from = top;
		this.position.to = top;
		this.position.frame = 1;
	}

	updateScrollCurrent() {
		const current = Math.round(this.position.from + easing[this.position.easing](this.position.duration - this.position.frame, 0, this.position.to - this.position.from, this.position.duration));
		this.position.current = current;
	}

	update() {
		const top = window.scrollY;

		this.updateDirection(top);

		if (top !== this.position.to) {
			if (this.jump) {
				this.jump = false;
				this.updateJumpTo(top);
			} else {
				this.updateScrollTo(top);
			}
		}

		if (this.position.frame > 0) {
			--this.position.frame;
			this.updateScrollCurrent();
			return true;
		}
	}

	render() {
		if (this.rendering) this.scrollContent.style.transform = `translate3d(0,-${this.position.current}px,0)`;
		document.body.classList[this.position.to <= 0 ? 'add' : 'remove']('is-top');
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		}, 'scroll');
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	scrollTo(top, jump) {
		this.jump = jump;
		window.scroll(false, top);
	}

	lockScroll() {
		document.documentElement.classList.add('scroll-locked');
	}

	unlockScroll() {
		document.documentElement.classList.remove('scroll-locked');
	}

	remove() {
		this.rendering = false;
		this.position.duration = 1;
		this.scrollWrapper.style.position = 'static';
		this.scrollContent.style.transform = '';
	}

	_onWindowLoad() {
		this.measure();
	}

	_onWindowResize() {
		this.measure();
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);
	}

}

export default new ScrollController();
